module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive/rowhouse-604426049ce2e8646bbd2bf6da1cb6bf.png";